<template>
    <div>
        <div class="row staff-filters">
            <div class="col-md-12 pb-3 mb-md-5">
                <div class="d-none d-md-block">
                    <ul class="nav nav-pills justify-content-md-center justify-content-lg-center staff-filters__cat">
                        <li class="nav-item staff-filters__cat__item mb-3 mb-lg-0">
                            <a :class="['nav-link', 'staff-filters__cat__item__link', currentDepartment == null ? 'active' : '']"
                                href="javascript:void(0)" v-on:click="filterByDepartment(null)">All</a>
                        </li>
                        <li v-for="dep in departments"
                            :class="['nav-item', 'staff-filters__cat__item', 'mb-3', 'mb-lg-0']">
                            <a :class="['nav-link', 'staff-filters__cat__item__link', currentDepartment == dep ? 'active' : '']"
                                href="javascript:void(0)" v-on:click="filterByDepartment(dep)">{{ dep.name }}</a>
                        </li>
                    </ul>
                </div>

                <div class="form-group bmd-form-group is-filled staff-filters__cat-mob form-group--arrow d-md-none">
                    <label for="newscat" class="bmd-label-floating">Filter by Category</label>
                    <select v-model="currentDepartment" class="form-control form-control--select" id="newscat"
                        name="newscat">
                        <option :value="null">Please select one</option>
                        <option v-for="dep in departments" :value="dep">{{ dep.name }}</option>
                    </select>
                </div>
            </div>
        </div>

        <div v-if="_.isEmpty(filteredList)" class="row mb-5">
            <div class="alert alert-secondary w-100 alert no-staff-alert">
                There is no staff members in this department.
            </div>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-sm-6 col-md-4" v-for="item in filteredList">
                    <a href="#staffModal" class="staff-list__card card card-btn shadow-0 mb-0"
                        v-on:click="() => currentStaff = item">
                        <div class="card-header border-0 rounded">
                            <img :src="_.imgPath((item.image), 'w800-h600-q80')"
                                :data-src="_.imgPath((item.image), 'w800-h600-q80')" :alt="item.name"
                                class="card-img-top blur-up lazyload image ">
                        </div>
                        <div class="card-body pt-3 pl-0">
                            <h4 class="mb-0">{{ item.name }}</h4>
                            <p class="text-green"><strong>{{ item.title }}</strong></p>
                        </div>
                    </a>
                </div>
            </div>
        </div>


        <!--Pop up modal-->
        <div id="staffModal" class="staff-modal">
            <!--THIS IS IMPORTANT! to close the modal, the class name has to match the name given on the ID -->
            <div id="btn-close-modal" class="close-staffModal">
                <img src="/img/site/icons/icon-close-gr.svg" alt="Close">
            </div>
            <div class="staff-content">
                <div class="d-sm-flex align-items-center staff-content__flex">
                    <!--Your modal content goes here-->
                    <div class="container">

                        <div class="row">
                            <div class="col-md-5 col-lg-5 staff-content__details staff-content__details--slideup">
                                <div class="relative">
                                    <template v-if="currentStaff">
                                        <img :src="_.imgPath(currentStaff.image, 'w50_h50')"
                                            :data-src="_.imgPath(currentStaff.image)" :alt="currentStaff.name"
                                            class="media-object staff-content__details__thumb img-fluid lazyload blur-up staff-content__details__photo lazyload-image">
                                        <a v-if="currentStaff.email" href="'mailto:' + currentStaff.email">
                                            <div class="green-box-btn green-box-btn--lg green-box-btn--mail"></div>
                                        </a>
                                    </template>
                                </div>

                            </div>
                            <div class="col-md-7 col-lg-7 staff-content__details staff-content__details--slideup2">
                                <div class="staff-content__details__title">
                                    <template v-if="currentStaff">
                                        <h1 class="w-100">{{ currentStaff.name }}<br /><span>{{ currentStaff.title
                                                }}</span></h1>
                                        <div v-html="currentStaff.content"></div>
                                        <p v-if="currentStaff.email">Email: <a :href="'mailto:' + currentStaff.email ">
                                                <strong>{{ currentStaff.email }}</strong></a></p>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>
<script>
import UtilsMixin from './UtilsMixin';

export default {
    data() {
        return {
            currentDepartment: '',
            currentStaff: null,
        }
    },

    mounted() {
        this.currentDepartment = null;
    },

    props: ['initialData'],

    components: {

    },

    mixins: [UtilsMixin],

    watch: {
        currentStaff(newVal, oldVal) {
            this.bindLazyloadEvent();

            // $('#staffModal').modal();

        },
        currentDepartment() {
            this.bindLazyloadEvent();
            this.bindModalEvent();
        },
    },

    computed: {
        staffMembers() {
            return _.chain(this.initialData)
                .get('staffMembers')
                .map(staff => {
                    const departments = _.chain(staff)
                        .get('departments')
                        .map(_.property('id'))
                        .value();

                    return _.assign({}, staff, { departments })
                })
                .value();
        },

        filteredList() {
            return _.chain(this.initialData)
                .get('staffMembers')
                .map(staff => {
                    const departments = _.chain(staff)
                        .get('departments')
                        .map(_.property('id'))
                        .value();

                    return _.assign({}, staff, { departments })
                })
                .filter(staff => {
                    let pass = true;

                    if (pass && this.currentDepartment) {
                        pass = _.includes(staff.departments, this.currentDepartment.id);
                    }

                    return pass;
                })
                .value();
        },

        departments() {
            return _.chain(this.initialData)
                .get('departments')
                .value();
        },
    },

    methods: {
        getStaffDepartments() {
            return _.chain(this.initialData)
                .get('categories')
                .find(cat => cat.id == post.news_category_id)
                .value();
        },

        filterByDepartment(department) {
            this.currentDepartment = department;
        },

        getStaffLink(staff) {
            return window.location.pathname + '/' + staff.name_id;
        },

        bindLazyloadEvent() {
            this.$nextTick(() => {
                $('img.lazyload-image').each((idx, el) => {
                    el.classList.remove('lazyloaded');
                    el.classList.add('lazyload');
                })
            })
        },

        bindModalEvent() {
            this.$nextTick(() => {
                if ($('.staff-list__card').length == 0) {
                    return;
                }

                console.log('binding modal');
                $(".staff-list__card").animatedModal({
                    animatedIn:'zoomIn',
                    animatedOut:'bounceOutDown',
                    color:'#39BEB9',
                    beforeOpen: function() {

                        function slideUpChild() {
                            setTimeout(
                                function()
                                {
                                    $('.staff-content__details--slideup').addClass('slide-up');
                                }, 500)
                            ;
                            setTimeout(
                                function()
                                {
                                    $('.staff-content__details--slideup2').addClass('slide-up');
                                }, 800);
                        }

                        slideUpChild();

                    },
                    afterClose: function() {
                        // $(".staff-content__details").removeClass('slide-up');
                        $(".layout-staff").css('overflow-x','hidden');
                    }
                });

                $('#btn-close-modal').on('click',function(){
                    // $('.staff-content__details--slideup').removeClass('slide-up'),
                    // $('.staff-content__details--slideup2').removeClass('slide-up');
                });
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/site/js/components/StaffListComponent.vue